<script setup lang="ts">
import { computed } from '#imports'
import BtnClose from '../components/BtnClose.vue'
import SkeletonDetails from '../components/Skeleton/Details.vue'
import TransitionFade from '../components/transition/Fade.vue'

const props = defineProps<{
  closeTo?: string
  hasFirstDataLoaded?: boolean
  isLoading?: boolean
}>()

const isSkeletonActive = computed(() => {
  return props.isLoading && !props.hasFirstDataLoaded
})
</script>

<template>
  <aside
    data-component="details_drawer"
    class="bg-surface z-60 max-w-screen md:w-3xl fixed bottom-0 right-0 top-0 flex h-screen w-full translate-x-0 transform-gpu flex-col border-l border-neutral-200 transition"
    aria-label="details-drawer"
  >
    <TransitionFade mode="out-in">
      <div
        v-if="isSkeletonActive"
        class="flex items-start justify-between px-8 pb-4 pt-8"
      >
        <div class="flex-1 animate-pulse">
          <div class="h-5.5 w-18 rounded-lg bg-neutral-200" />
          <div class="w-4.5/5 h-5.5 mt-2 rounded-lg bg-neutral-200" />
        </div>
        <BtnClose v-if="closeTo" :to="closeTo" />
      </div>
      <div v-else>
        <slot name="header" />
      </div>
    </TransitionFade>

    <div class="flex-1 overflow-y-auto overscroll-contain">
      <TransitionFade mode="out-in">
        <SkeletonDetails v-if="isSkeletonActive" />
        <div v-else class="h-full">
          <slot />
        </div>
      </TransitionFade>
    </div>
  </aside>
</template>
